<template>
  <div class="project-device-manage">
    <template v-if="!deviceDialog.show">
      <div class="app-title">设备管理</div>
      <div class="app-control app-table-control">
        <el-button type="primary" @click="add">新增设备</el-button>
        <div class="right-region">
          <el-input placeholder="请输入设备名称或编号" v-model="search.value" clearable></el-input>
          <el-button type="primary" @click="searchParams">搜索</el-button>
          <el-button @click="resetParams">重置</el-button>
        </div>
      </div>
      <div v-loading="loading">
        <div class="device" :class="{'device-1': value.isBox, 'device-2': value.isAio}" v-for="(value, index) in datas" :key="index">
          <template v-if="value.isBox">
            <div class="app-control">
              <div class="img"></div>
              <div class="info">
                <p>{{value.device_name}}</p>
                <p>{{value.device_sn}}</p>
                <el-tag type="info" size="small" v-if="value.is_deleting === 1">删除中</el-tag>
                <template v-else>
                  <el-tag type="success" size="small" v-if="value.is_online">在线</el-tag>
                  <el-tag type="info" size="small" v-else>离线</el-tag>
                </template>
              </div>
              <div class="right-region">
                <el-button type="text" @click="edit(value.device_id)">编辑</el-button>
                <el-button type="text" @click="restart(value.device_id)">重启</el-button>
                <el-button type="text" @click="del(value.device_id)">删除</el-button>
              </div>
            </div>
            <div class="wrap">
              <project-camera-manage :deviceId="value.device_id" :ref="`projectCameraManage-${value.device_id}`"></project-camera-manage>
            </div>
          </template>
          <template v-if="value.isAio">
            <div class="app-control">
              <div class="img"></div>
              <div class="info">
                <p>{{value.device_name}}</p>
                <p>{{value.device_sn}}</p>
                <el-tag type="info" size="small" v-if="value.is_deleting === 1">删除中</el-tag>
                <template v-else>
                  <el-tag type="success" size="small" v-if="value.is_online">在线</el-tag>
                  <el-tag type="info" size="small" v-else>离线</el-tag>
                </template>
              </div>
              <div class="right-region">
                <el-button type="text" @click="paramSettings(value.device_id)">参数配置</el-button>
                <el-button type="text" @click="edit(value.device_id)">编辑</el-button>
                <el-button type="text" @click="del(value.device_id)">删除</el-button>
              </div>
            </div>
          </template>
        </div>
        <div class="empty" v-if="!datas.length"><i class="el-icon-warning"></i>暂无数据</div>
      </div>
      <el-dialog :title="deviceParamSettingsDialog.title" :visible.sync="deviceParamSettingsDialog.show" center :width="dialogWidth" append-to-body>
        <project-device-param-settings v-if="deviceParamSettingsDialog.show" :deviceId="deviceParamSettingsDialog.id" @submit="deviceParamSettingsDialog.show = false" @cancel="deviceParamSettingsDialog.show = false"></project-device-param-settings>
      </el-dialog>
    </template>
    <project-device-info v-else :deviceId="deviceDialog.id" @submit="initDatas" @cancel="deviceDialog.show = false"></project-device-info>
  </div>
</template>

<script>
  import ProjectService from '@/io/project.js';
  import ProjectDeviceInfo from '@/views/ProjectDeviceInfo.vue';
  import ProjectCameraManage from '@/views/ProjectCameraManage.vue';
  import ProjectDeviceParamSettings from '@/views/ProjectDeviceParamSettings.vue';

  export default {
    name: 'ProjectDeviceManage',
    data() {
      return {
        loading: false,
        id: this.$route.params.id,
        search: {
          value: ''
        },
        datas: [],
        deviceDialog: {
          show: false,
          title: '',
          id: null
        },
        deviceParamSettingsDialog: {
          show: false,
          title: '',
          id: null
        }
      }
    },
    components: {
      ProjectDeviceInfo,
      ProjectCameraManage,
      ProjectDeviceParamSettings
    },
    mounted () {
      this.initDatas();
    },
    methods: {
      switchShowCamera(data) {
        data.showCamera = !data.showCamera;
      },
      initCameraDatas() {
        this.$refs[`projectCameraManage-${this.cameraDialog.id}`][0].initDatas();
      },
      initDatas() {
        this.loading = true;
        ProjectService.deviceList(
          this.id,
          this.search.value
        ).then(res => {
          this.datas = [];
          this.$nextTick(() => {
            this.datas = res.data.map(val => {
              let isBox = val.device_type_sign === 'device_control_box';
              let isAio = val.device_type_sign === 'device_control_aio';
              val.isBox = isBox;
              val.isAio = isAio;
              if (isBox) {
                val.showCamera = false;
              }
              return val;
            });
          });
        }).catch(() => {}).finally(() => {
          this.loading = false;
        });
      },
      add() {
        this.deviceDialog.title = '新增设备';
        this.deviceDialog.id = null;
        this.deviceDialog.show = true;
      },
      edit(id) {
        this.deviceDialog.title = '编辑设备';
        this.deviceDialog.id = id;
        this.deviceDialog.show = true;
      },
      del(id) {
        this.$confirm(
          '确认删除?',
          '提示',
          {
            type: 'warning'
          }
        ).then(() => {
          return ProjectService.delDevice(this.id, id);
        }).then(res => {
          return this.initDatas();
        }).then(res => {
          this.$message.success('删除成功');
        }).catch(() => {});
      },
      paramSettings(id) {
        this.deviceParamSettingsDialog.title = '参数设置';
        this.deviceParamSettingsDialog.id = id;
        this.deviceParamSettingsDialog.show = true;
      },
      restart(id) {
        ProjectService.restartBox(this.id, id).then(() => {
          this.$message.success('重启成功');
        }).catch(() => {});
      },
      searchParams() {
        this.initDatas();
      },
      resetParams() {
        this.search.value = '';
        this.searchParams();
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .project-device-manage {
    .add {
      padding: 20px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px dashed @color-border-1;
      color: @color-text-3;
      cursor: pointer;
      transition: all @time;
      &:hover {
        border-color: @color-primary;
        color: @color-primary;
      }
      i {
        margin-right: 5px;
      }
    }
    .empty {
      opacity: .5;
      display: flex;
      flex-direction: column;
      align-items: center;
      i {
        font-size: 24px;
        margin-bottom: 5px;
      }
    }
    .device {
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, .1);
      & + .device {
        margin-top: 20px;
      }
      &.device-1 {
        .img {
          .setImg('/project-edit-manage/device-1.png');
        }
      }
      &.device-2 {
        .img {
          .setImg('/project-edit-manage/device-2.png');
        }
      }
      & > .app-control {
        padding: 20px;
        height: 100px;
        position: relative;
        overflow: hidden;
        .img {
          width: 100px;
          height: 100px;
          margin-right: 20px;
        }
        .info {
          p {
            margin-bottom: 12px;
          }
        }
        .btn {
          width: 60px;
          height: 30px;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translate3d(-50%, 0, 0);
          font-size: 18px;
          background-color: @color-primary;
          color: @color-white;
          border-radius: 30px 30px 0 0;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }
      .wrap {
        border-top: 1px dashed @color-border-1;
        margin: 0 20px;
      }
    }
  }
</style>